import code from "./images/code.png";
import slack from "./images/slack.png";
import trackr from "./images/trackr.png";
import instructive from "./images/instructive.png";
import share from "./images/share.png";
import sneaks from "./images/sneaks.png";
import netflix from "./images/netflix.png";
import solid from "./images/solid-ecommerce.png";
import trello_dupe from "./images/trello_dupe.png";

const works = [
    {
    id: 17,
    img:  instructive,
    title: "instructive",
    github: "https://github.com/bisoladebiyi/instructive-lms-client",
    site: "https://instructive-lms.netlify.app/",
    tech: ["React", "Typescript", "Rails", "TailwindCSS", "MUI"],
  },
    {
    id: 16,
    img: trackr,
    title: "trackr",
    github: "https://github.com/bisoladebiyi/trackr-fe",
    site: "https://trackr-fe.vercel.app/",
    tech: ["Next.js", "FastAPI", "Python", "TailwindCSS"],
  },
  {
    id: 15,
    img: trello_dupe,
    title: "Trello Dupe",
    github: "https://github.com/bisoladebiyi/trello-dupe/",
    site: "https://trello-dupe.vercel.app/",
    tech: ["React.js", "Firebase", "Typescript", "TailwindCSS"],
  },
  {
    id: 14,
    img: netflix,
    title: "Netflix Clone",
    github: "https://github.com/bisoladebiyi/netflix-clone",
    site: "https://bee-netflix-clone.vercel.app/",
    tech: ["Next.js", "Redux toolkit", "Typescript", "Styled Components"],
  },
  {
    id: 13,
    img: sneaks,
    title: "Sneaks E-commerce site",
    github: "https://github.com/bisoladebiyi/sneaks",
    site: "https://sneaks-from-bee.netlify.app/",
    tech: ["React", "Redux toolkit", "Material UI", "Paystack"],
  },
  {
    id: 12,
    img: slack,
    title: "Slack Clone",
    github: "https://github.com/bisoladebiyi/slack-clone",
    site: "https://slack-clone-277f2.web.app/",
    tech: ["React", "Redux", "Firebase", "Styled Components", "Material UI"],
  },
  {
    id: 10,
    img: share,
    title: "Share Social App",
    github: "https://github.com/bisoladebiyi/share",
    site: "https://share-one.vercel.app/",
    tech: ["Next.js", "Firebase", "Material UI"],
  },
  {
    id: 9,
    img: solid,
    title: "Solid E-commerce site",
    github: "https://github.com/bisoladebiyi/solid-ecommerce",
    site: "https://solid-ecommerce-site.netlify.app/",
    tech: ["Solid.js", "Typescript", "TailwindCSS"],
  },

  {
    id: 8,
    img: code,
    desc: "A code editor for testing and showcasing HTML, CSS and JavaScript code. Built with react and tailwind",
    addclass: "work switch",
    title: "Code Editor",
    github: "https://github.com/bisoladebiyi/code-editor",
    site: "https://codeditor-react.netlify.app/",
    tech: ["React", "TailwindCSS"],
  }
];
export default works;
